<template>
  <div class="musoon">
    <a href="https://www.musoonclinic.com.tw"
      ><img src="@/assets/images/logo.jpg" width="60"
    /></a>
    <p>木生婦幼診所</p>
    <p>v{{ version }}</p>
    <br />
    <p class="inncom">創實雲端科技有限公司</p>
    <p class="inncom">Inncom Cloud Technology Co., Ltd.</p>
  </div>
</template>

<style scoped>
.musoon {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  font-size: 0.8rem;
  margin: 2rem;
}
img {
  margin: 1rem;
}
.inncom {
  font-size: 0.6rem;
}
</style>

<script>
export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      stage: process.env.VUE_APP_STAGE,
      version: process.env.VUE_APP_VERSION
    };
  },
  mounted() {}
};
</script>
